// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import '../../../styles/components/ActivitiesList.css';
import NoImage from '../../../NoImage.png';
import Sorter from '../../utils/Sorting/Sorter';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import { getConfig } from '../../../config';

import ActivitiesListMobile from './ActivitiesListMobile';

export default class ActivitiesList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event, event.currentTarget.getAttribute('href'));
  };

  changeSort = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeSort } = this.props;
    event.stopPropagation();
    event.preventDefault();
    changeSort(event.currentTarget.getAttribute('name'));
  };
  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { activities, activeSort } = this.props;

    if (isMobileResolution()) {
      return (
        <ActivitiesListMobile
          activities={activities}
          handleOnClick={this.handleOnClick}
        />
      );
    }

    const config = getConfig();

    return (
      <div className='activitieslist'>
        <Table hover>
          <thead>
            <tr>
              <th>Photo</th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='title'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Name <Sorter activeSort={activeSort} name='title' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='city'
                className='sortColumn'
                onClick={this.changeSort}
              >
                City <Sorter activeSort={activeSort} name='city' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='bookable'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Bookable <Sorter activeSort={activeSort} name='bookable' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='featured'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Featured <Sorter activeSort={activeSort} name='featured' />{' '}
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='popularity'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Popularity <Sorter activeSort={activeSort} name='popularity' />{' '}
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='bachified'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Bachified <Sorter activeSort={activeSort} name='bachified' />{' '}
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='actions'
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {activities.map(activity => (
              <tr
                key={activity.id}
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                href={`${config.batchAdminURL}/experiences/${activity.id}`}
                className='listrow'
                onClick={this.handleOnClick}
              >
                <td>
                  <img
                    src={
                      activity.media?.length > 0
                        ? `${activity.media[0].url}?tr=w-600`
                        : NoImage
                    }
                    style={{ width: '100px', height: '100px' }}
                    alt='...'
                    className='img-thumbnail'
                  />
                </td>
                <td style={{ width: '30%', verticalAlign: 'middle' }}>
                  {activity.title}
                </td>
                <td style={{ width: '20%', verticalAlign: 'middle' }}>
                  {activity.city}
                </td>
                <td style={{ width: '10%', verticalAlign: 'middle' }}>
                  {activity.bookable ? 'Yes' : 'No'}
                </td>
                <td style={{ width: '10%', verticalAlign: 'middle' }}>
                  {activity.featured ? 'Yes' : 'No'}
                </td>
                <td style={{ width: '20%', verticalAlign: 'middle' }}>
                  {activity.popularity}
                </td>
                <td style={{ width: '20%', verticalAlign: 'middle' }}>
                  {activity.bachified ? 'Yes' : 'No'}
                </td>
                <td
                  onClick={event => {
                    event.stopPropagation();
                  }}
                >
                  <a href={`/activities/${activity.id}`}>Open in BAT</a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
